module.exports = __webpack_public_path__ + "static/media/400334_01.7730e450.png";